import React from 'react';
import TacticSelectionSection from './TacticSelectionSection';
import { DEFENSIVE_TACTICS_OPTIONS } from '../../../constants/coachTactics';

/**
 * DEFENSIVE TACTICS. See PlayingStyleSection.js for why the body moved out.
 * Its twin is OffensiveTacticsSection.js, which was missing entirely until now.
 */
const DefensiveTacticsSection = ({ isEditing, defensiveTactics = [], onUpdateDefensiveTactics }) => (
  <TacticSelectionSection
    isEditing={isEditing}
    values={defensiveTactics}
    onUpdate={onUpdateDefensiveTactics}
    options={DEFENSIVE_TACTICS_OPTIONS}
    title="DEFENSIVE TACTICS"
    addButtonLabel="+ Add Defensive Tactic"
    emptyLabel="No defensive tactics information available"
    modalTitle="ADD DEFENSIVE TACTIC"
    selectLabel="Select Defensive Tactic"
    selectPlaceholder="Select a defensive tactic"
    removeAriaLabel="Remove defensive tactic"
  />
);

export default DefensiveTacticsSection;
